import React, { useState } from "react";
import { Col, Collapse } from "react-bootstrap";
import { SectionHeader } from "./SectionHeader";

export function Awards(props) {
    const [collapse, setCollapse] = useState(true);

    const items = props.data.map((award, i) => {
        return (
            <Col className="pad-15" key={i}>
                <SectionHeader name={`${award.title}`} size={"m"} right={award.year ? award.year : ""} />
                <p id="desc">
                    {award.description}
                </p>
            </Col>
        );
    });

    return (
        <span>
            <div ref={props.reff} style={{ position: 'relative', bottom: 50 }} />
            <SectionHeader name={props.name} collapse={collapse} setCollapse={setCollapse} collapsable="true" />
            <Collapse in={collapse}>
                <div>
                    {items}
                </div>
            </Collapse>
        </span>
    )
}
